import { reactive } from 'vue'

export const userState = reactive({
  //isAdmin: false,
  notifications: true, // Whether to show banner notifications.
})